import { isTruthy } from "@dashboard/library";
import { CallDetailsFragment } from "@/graphql/generated/graphql";

export const mapToUtteranceSentiments = (
  transcription: CallDetailsFragment["transcription"] | null
) => {
  if (transcription?.__typename === "CallTranscription") {
    const sentimentsArr = (
      transcription?.insights?.sentiments?.customers?.utterances ?? []
    ).filter(isTruthy);

    return new Map(
      sentimentsArr.map((sentiment) => [sentiment.index, sentiment])
    );
  }
};
